import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { components, api } from '@seaoil/component-lib';
import moment from 'moment';
import { LayoutWithNav } from '../components/Layout';

const { Auth } = components;
const { mySEAOIL } = api;

function WorkflowExec() {
  const { execArn } = useParams();
  const AuthContext = Auth.useContext();
  const [state, setState] = useState({
    status: 'INITIALIZING',
    data: {},
  });

  if (AuthContext.status === 'LOGGED_IN'
    && state.status === 'INITIALIZING') {
    mySEAOIL.workflow.getExecution({
      execution_arn: execArn,
    }).send().then((result) => {
      setState({
        status: 'COMPLETE',
        data: result,
      });
    });
  }

  const getTitle = () => {
    if (!state.data.workflow_name) return null;
    return `${state.data.workflow_name} v${state.data.workflow_version}`;
  };

  const printDate = (isoD) => {
    const dateFmt = 'dddd, MMMM D YYYY, h:mm:ss a';
    if (!isoD) return 'n/a';
    const d = moment(isoD);
    if (!d.isValid()) return 'n/a';

    return `${d.format(dateFmt)} (${d.fromNow()})`;
  };

  const currentState = state.data.current_state || {};

  return (
    <Auth.PrivateComponent redirect="/login">
      <LayoutWithNav>
        <div>
          <div>
            <div>Workflow:</div>
            <div style={{ fontSize: '150%' }}>{getTitle()}</div>
          </div>
          <div>
            <div>Status:</div>
            <div style={{ fontSize: '150%' }}>{state.data.workflow_status}</div>
          </div>
          <div>
            <div>Start:</div>
            <div style={{ fontSize: '150%' }}>{printDate(state.data.start_date)}</div>
          </div>
          <div>
            <div>Stop:</div>
            <div style={{ fontSize: '150%' }}>{printDate(state.data.stop_date)}</div>
          </div>
          <hr />
          <div>
            <div>Current State:</div>
            <div style={{ fontSize: '150%' }}>{currentState.name}</div>
          </div>
          <div>
            <div>Owner:</div>
            <div style={{ fontSize: '150%' }}>{(currentState.owner || []).join(', ')}</div>
          </div>
          <div>
            <div>Started At:</div>
            <div style={{ fontSize: '150%' }}>{printDate(currentState.started_at)}</div>
          </div>
          <div>
            <div>Finished At:</div>
            <div style={{ fontSize: '150%' }}>{printDate(currentState.finished_at)}</div>
          </div>
        </div>
      </LayoutWithNav>
    </Auth.PrivateComponent>
  );
}

export default WorkflowExec;
